import logoSign from '@/assets/landing/logo-sign.svg';
import logoText from '@/assets/landing/logo-text.svg';
import { cn } from '@/shared/lib/cn';

/**
 * Rozmiary lockupu: wysokosc sygnetu, wysokosc napisu (ok. 2/3 sygnetu — proporcja
 * z landingu: sygnet 78px, napis 52px) i odstep miedzy nimi.
 */
const lockupSizes = {
  sm: { sign: 'h-8', text: 'h-[1.3125rem]', gap: 'gap-1.5' },
  md: { sign: 'h-10', text: 'h-[1.6875rem]', gap: 'gap-2' },
  lg: { sign: 'h-14', text: 'h-[2.3125rem]', gap: 'gap-2.5' },
} as const;

/** Rozmiary samego sygnetu — do zwinietego paska bocznego. */
const markSizes = {
  sm: 'h-12',
  md: 'h-16',
  lg: 'h-18',
} as const;

export interface LogoProps {
  size?: keyof typeof lockupSizes;
  /** Ukrywa napis i zostawia sam znak — do zwinietego paska bocznego. */
  markOnly?: boolean;
  className?: string;
}

/**
 * Logo Tenify — oryginalny branding z landingu (Figma tenify.pl): zolty sygnet
 * (`logo-sign.svg`) + zolty napis (`logo-text.svg`). Te same pliki serwuje landing
 * i strona logowania, wiec kazdy widok aplikacji pokazuje identyczny znak.
 *
 * Kolor (#FAFF37) jest zapieczony w plikach — logo jest projektowane na ciemne tla,
 * dlatego domyslny motyw aplikacji to ciemny.
 */
export function Logo({ size = 'md', markOnly = false, className }: LogoProps) {
  if (markOnly) {
    return (
      <span className={cn('inline-flex items-center', className)}>
        <img
          src={logoSign}
          alt="Tenify"
          draggable={false}
          className={cn('w-auto', markSizes[size])}
        />
      </span>
    );
  }

  const { sign, text, gap } = lockupSizes[size];

  return (
    <span className={cn('inline-flex items-center', gap, className)}>
      <img src={logoSign} alt="" draggable={false} className={cn('w-auto', sign)} />
      <img src={logoText} alt="Tenify" draggable={false} className={cn('w-auto', text)} />
    </span>
  );
}
